import React from 'react'
import { Brand } from '../../pages/admin/embeds/embedsV2/interface';
import imagePlaceholder from '../../assets/svg/image_placeholder.svg';
import { useBrandDetailLink } from '../../hooks/useBrandDetailLink';

interface BrandInlineListProps {
  brands: Partial<Brand>[];
  showSeparator?: boolean;
  navigable?: boolean;
}
const BrandInlineList = ({ brands, showSeparator = true, navigable = false }: BrandInlineListProps) =>{
  const { enabled, goToBrand } = useBrandDetailLink();
  if (!brands || brands.length === 0) return null;

  const clickable = navigable && enabled;

  return (
    <div className="flex items-center gap-3 flex-wrap min-w-0">
      {brands.map((brand, index) => {
        const canClick = clickable && brand.id != null;
        return (
        <React.Fragment key={brand.id || index}>
          {/* Separator: Show if enabled AND it's not the first item */}
          {showSeparator && index > 0 && (
            <div className="text-[14px] font-[450] text-text-2 shrink-0">|</div>
          )}
          <div
            className={`flex items-center gap-2 shrink-0${canClick ? ' cursor-pointer' : ''}`}
            onClick={
              canClick
                ? (e) => {
                    e.stopPropagation();
                    goToBrand(brand.id);
                  }
                : undefined
            }
          >
            <img
              className="w-[24px] h-[24px] object-cover rounded-[6px] shrink-0 bg-surface-2"
              src={brand.logo || `https://img.logo.dev/${brand.name?.replace(/\s+/g, '')}.com?token=pk_fw3EgsMdRnKqF-72FUrrmQ`}
              alt={brand?.name}
              onError={(e) => {
                (e.target as HTMLImageElement).src = imagePlaceholder;
              }}
            />
            <div className={`text-[14px] font-[450] text-text-1 whitespace-nowrap${canClick ? ' hover:text-accent-text' : ''}`}>
              {brand.name}
            </div>
          </div>
        </React.Fragment>
        );
      })}
    </div>
  );
}

export default BrandInlineList